import {
  ReportSection,
  ReportSectionConfigurationBase,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';
import { PeerOwnershipInstitutionsCountryTerritoryViewModel } from './peer-ownership-institutions-breakdown.model';

export class PeerOwnershipInstitutionsCountryTerritoryConfiguration extends ReportSectionConfigurationBase {
  typeName = 'PeerOwnershipInstitutionsCountryTerritoryConfiguration';
  nodataLocalizationKeyName = 'peerOwnershipInstitutionsCountryTerritory';
  readonly reportSection = ReportSection.PeerOwnershipInstitutionsCountryTerritory;
  readonly name = 'peerOwnershipInstitutionsCountryTerritory';
  readonly displayName = 'Country/Territory - Institutions';
  readonly applicableReportTypes = [ReportType.PeerOwnershipReport];
  readonly reportViewModelSections = [ReportViewModelSection.PeerOwnershipReport_InstitutionsCountryTerritory];
  minSize = 2;
  maxSize = 4;
  defaultSize = 2;
  readonly availableDataSections = [];
}

export interface PeerOwnershipInstitutionsCountryTerritoryDataBag {
  [ReportViewModelSection.PeerOwnershipReport_InstitutionsCountryTerritory]: PeerOwnershipInstitutionsCountryTerritoryViewModel;
}
